// This runs in the authenticated Gab web frame, never in the extension or X.
// Only bounded post context, photo URLs and generated text cross the panel bridge.
import { xReplyContext } from '../browser-extension/x-reply-context';
export function validXReply(request) {
  return !!request && /^[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12}$/i.test(request.id || '') &&
    typeof request.extraGuidance === 'string' && request.extraGuidance.length <= 2000 && !!xReplyContext(request);
}

export function createXReplyGenerator({ getState, fetchWithAuth, send }) {
  const seen = new Set();
  let active;
  return {
    cancel(id) { if (!id || active?.id === id) active = null; },
    async generate(request) {
      if (!validXReply(request) || seen.has(request.id)) return;
      seen.add(request.id);
      if (seen.size > 100) seen.delete(seen.values().next().value);
      const initial = getState();
      if (!initial.token || !initial.user?.id || initial.user.flags?.isGhost || initial._isSigningOut) {
        send('x-reply-result', { id: request.id, error: 'Sign in to Gab AI under Options, then Reload chat and choose Generate reply.' }); return;
      }
      const current = { id: request.id }; active = current;
      const valid = () => active === current && getState().user?.id === initial.user.id &&
        getState()._sessionGeneration === initial._sessionGeneration && !!getState().token && !getState()._isSigningOut;
      try {
        const context = xReplyContext(request);
        const videoPreviewCount = context.contextChain.reduce((sum, item) => sum + (item.videoPreviews?.length || 0), 0);
        const imageCount = context.contextChain.reduce((sum, item) => sum + (item.images?.length || 0), videoPreviewCount);
        const result = await fetchWithAuth(imageCount ? '/extension/x/generate-image-response' : '/extension/x/generate-response', {
          method: 'POST', timeoutMs: 110000, networkRetries: 0, isRequestCurrent: valid,
          body: { postId: request.postId, contextChain: context.contextChain, extraGuidance: request.extraGuidance },
        });
        if (!valid()) return;
        if (videoPreviewCount && result.videoPreviewCount !== videoPreviewCount) throw new Error('Gab AI could not confirm the video preview was included. Please try again.');
        if (imageCount && result.imageCount !== imageCount) throw new Error('Gab AI could not confirm the attached images were included. Please try again.');
        if (result.error || typeof result.content !== 'string' || !result.content.trim() || result.content.length > 12000) throw new Error('Arya returned no usable reply. Please try again.');
        send('x-reply-result', { id: request.id, content: result.content });
      } catch (error) {
        if (valid()) send('x-reply-result', { id: request.id, error: error.message?.slice(0, 500) || 'Could not generate a reply. Please try again.' });
      } finally { if (active === current) active = null; }
    },
  };
}
